import {
  getFormat,
  mandbRetailers,
  toTimestamp
} from '../utilities'
import { ProductDetails } from './ProductDetails'
import { contributorsList } from '../utils/get-contributors-list'

export class MandBProductDetails extends ProductDetails {
  constructor (client, isbn) {
    super(client, isbn)
    this.addPageEvent(this.mountSeriesLink)
    this.addPageEvent(this.hideProductFormIfBeforeSalesDate)
    this.addPageEvent(this.initAuthorBookCarousel)
    this.addPageEvent(this.initTitleChildren)
    this.addPageEvent(this.initMAndBRetailerDropdown)
    this.addPageEvent(this.initMandBContributorBios)
  }

  mountSeriesLink () {
    if (!this.bookData.series || !this.bookData.series.series || !this.bookData.series.series.length) {
      return
    }
    const seriesData = this.bookData.series.series
    const seriesLinkWrapper = document.querySelector('.js-mandb-series-link-wrapper')
    const seriesName = seriesData[0].name ? seriesData[0].name : ''
    if (!seriesLinkWrapper && !seriesName) {
      return
    }
    seriesLinkWrapper.innerHTML = `<a href="/search/?dFR[series][0]=${seriesName}">${seriesName}</a>`
  }

  hideProductFormIfBeforeSalesDate () {
    let publicationDate = null

    if (this.bookData.date && this.bookData.date.date) {
      publicationDate = new Date(this.bookData.date.date.replace(/ /g, 'T'))
    }

    // Hide form if sales date not available
    if (!publicationDate) {
      document.querySelector('.js-mandb-form-wrapper').style.display = 'none'
      return
    }

    // hide sales date if before today
    const publicationDateTimestamp = toTimestamp(publicationDate)
    let today = new Date()
    today = toTimestamp(today)
    if (publicationDateTimestamp > today) {
      document.querySelector('.js-mandb-form-wrapper').style.display = 'none'
    }
  }

  /**
   * Mount contributor bios
   */
  initMandBContributorBios () {
    const contributorsData = this.bookData.contributors

    if (!contributorsData || !contributorsData.length) {
      return
    }

    const section = document.querySelector('.js-mandb-contributor-section')
    const bioMount = section ? section.querySelector('.js-mandb-contributor-bio-mount') : null

    if (!section || !bioMount) return

    const constributorBios = contributorsData.map(contributor => {
      if (contributor.contributor && contributor.contributor.name && contributor.contributor.bio) {
        const contributorData = contributor.contributor
        const contributorID = contributorData.contributor_id

        const contributorLink = ` https://${window.Shopify.shop}/collections/vendors?q=${contributorData.name}:::${contributorID}&contributorID=${contributorID}`
        let contributorBio = contributor.contributor.bio.substr(0, 550)
        // make sure that text breaks on a space
        contributorBio = contributorBio.substr(0, Math.min(contributorBio.length, contributorBio.lastIndexOf(' ')))
        contributorBio = `${contributorBio}... <a href="${contributorLink}" title="${contributorData.name}">more</a>`

        const htmlArray = ['<div class="mandb-contributor__inner">']

        if (contributorData.image) {
          htmlArray.push(`<img class="mandb-contributor__image" src="${contributorData.image}" alt="${contributorData.name}">`)
        }

        htmlArray.push(`<div class="mandb-contributor__bio"><h4>${contributorData.name}</h4>${contributorBio}</div>`)
        // close .mandb-contributor__inner div
        htmlArray.push('</div>')

        return htmlArray.join('')
      }
    })

    if (constributorBios[0] === undefined) return

    constributorBios.forEach(bio => {
      bioMount.insertAdjacentHTML('beforeend', bio)
    })

    section.style.display = 'block'
  }

  initMAndBRetailerDropdown () {
    if (!this.bookData.formats || !this.bookData.formats.length) {
      return
    }
    const currentFormatData = getFormat(this.bookData.isbn13, this.bookData.formats)
    const formatCode = currentFormatData.format.code
    const isbn = this.bookData.isbn13

    if (!formatCode || !isbn) {
      return
    }
    const mandbRetailersData = formatCode === 'DG' ? mandbRetailers.eBook : mandbRetailers.default
    const mandbRetailerSelectElement = document.querySelector('.js-mandb-retailer-select')
    if (!mandbRetailerSelectElement) {
      return
    }
    mandbRetailersData.forEach(retailer => {
      retailer.url = retailer.url.replace('{isbn}', isbn)
      mandbRetailerSelectElement.insertAdjacentHTML('beforeend', `<option value="${retailer.url}">${retailer.name}</option>`)
    })
  }

  // TODO: currently adds a new call to the service
  initAuthorBookCarousel () {
    const section = document.querySelector('.js-more-author-books-section')
    const container = section ? section.querySelector('.js-more-author-books') : null
    const moreButton = section ? section.querySelector('.js-author-more-btn') : null
    const instance = this

    if (!section || !container) return

    if (!this.bookData || !this.bookData.contributors || !this.bookData.contributors.length) return

    // get author ID of first contributor with A01 role id
    const authorData = this.bookData.contributors.find(contributor => contributor.role_id === 'A01')
    const authorId = authorData ? authorData.contributorID : ''

    if (!authorId) return

    // required to get author books and then init a book grid from the results handler
    instance.client.addDetailsWidget({
      container,
      static: {
        contributors: true
      },
      objectID: authorId,
      source: 'contributors',
      resultHandler (item) {
        if (!item.books.length) {
          return item
        }
        // only show books that do not match the current isbn and are not hidden in the feed
        const bookIsbns = item.books.filter(book => book.isbn13 != instance.isbn && book.hide === false).map(book => book.isbn13).slice(0, 5)
        if (!bookIsbns.length) {
          return item
        }
        instance.client.addLookupWidget({
          container,
          objectIDs: bookIsbns,
          static: true,
          source: 'products',
          carousel: false,
          resultHandler (item) {
            if (!item.custom.handle || typeof item.custom.handle !== 'string') {
              console.error(item.isbn13 + ' : item is missing custom.handle')
              return item
            }
            item.shopifyUrl = `/products/${item.custom.handle}`
            item.activeCurrency = item.prices.length && window.theme.settings.supaduCurrency.currency_iso ? item.prices.filter(price => price.locale === window.theme.settings.supaduCurrency.currency_iso)[0] : null
            item.currencyString = window.theme.settings.supaduCurrency.currency_symbol && item.activeCurrency && item.activeCurrency.amount ? `${window.theme.settings.supaduCurrency.currency_symbol}${item.activeCurrency.amount}` : ''
            return item
          },
          classes: {
            columns: 'supadu-product-grid__item small--one-half medium-up--one-fifth'
          },
          templates: {
            item: `
                  {{#if item.shopifyUrl }}
                  <a href="{{ item.shopifyUrl }}">
                    <div class="supadu-product-grid__image-wrapper js-product-grid-image-wrapper">
                      <div class="supadu-product-grid__image-outer">
                        <div class="supadu-product-grid__image-inner">
                          <img class="supadu-product-grid__image" src="{{ item.image }}" alt="{{ item.title }}">
                        </div>
                      </div>
                    </div>
                    <div class="grid-product__meta">
                      <div class="grid-product__title grid-product__title--body">{{ item.title }}</div>
                      {{#if item.currencyString }}
                      <div class="grid-product__price">
                        {{ item.currencyString }}
                      </div>
                      {{/if}}
                    </div>
                  </a>
                  {{/if}}
              `
          }
        }).then(() => {
          if (item.books.length > 5 && authorData.contributor.name && authorData.contributorID) {
            moreButton.setAttribute('href', `/collections/vendors?q=${authorData.contributor.name}:::${authorData.contributorID}&contributorID=${authorData.contributorID}`)
            moreButton.style.display = 'block'
          }

          section.style.display = 'block'

          Array.from(section.querySelectorAll('.js-product-grid-image-wrapper')).forEach(gridItem => {
            window.maintainSquareRatio(gridItem)
          })
        })

        return item
      }
    })
  }

  initTitleChildren () {
    if (!this.bookData || !this.bookData.custom) {
      return
    }

    const bookData = this.bookData
    const childISBNs = bookData.custom.child_handles && Object.keys(bookData.custom.child_handles) ? Object.keys(bookData.custom.child_handles) : []

    if (!childISBNs.length) {
      return
    }

    const wrapper = document.querySelector('.js-mandb-child-titles-wrapper')
    const container = document.querySelector('.js-mandb-child-titles')

    if (!wrapper || !container) {
      return
    }

    this.client.addLookupWidget({
      container,
      objectIDs: Object.keys(bookData.custom.child_handles),
      source: 'products',
      static: true,
      carousel: false,
      perRow: 1,
      itemAlign: 'left',
      templates: {
        item: `
                {{#if item.shopifyUrl}}
                  <div class="mandb-child-titles__image-wrapper"><img src="{{ item.image }}" alt="{{ item.alt }}"></div>
                  <div class="mandb-child-titles__info-wrapper">
                    <a href="{{ item.shopifyUrl }}"><h3>{{ item.title }}</h3></a>
                    {{#if item.contributorList}}
                    <div class="product-vendor">
                        {{#each item.contributorList}}
                        <p class="product-contributors">{{{this}}}</p>
                        {{/each}}
                    </div>
                    {{/if}}
                    <div class="mandb-child-titles__buy-section">
                      <a href="{{ item.shopifyUrl }}" class="btn mandb-child-titles__more-info-btn">More Details</a>

                      <span class="mandb-child-titles__or">or</span>

                      <select class="mandb-product-single-form__retailer-select" onchange="window.location.href = this.value">
                        <option>Buy From</option>
                        <option value="http://booktopia.sjv.io/c/1426282/584131/9632?&amp;u=http://www.booktopia.com.au/prod{{ item.isbn13 }}.html">Booktopia</option>
                        <option value="http://t.dgm-au.com/c/32028/137028/2741?&amp;u=http://www.angusrobertson.com.au/book/{{ item.isbn13 }}">A&amp;R</option>
                        <option value="http://ads.harpercollins.com/thenile?isbn={{ item.isbn13 }}&amp;retailer=nile&amp;locale=au">The Nile</option>
                        <option value="http://ads.harpercollins.com/hc?isbn={{ item.isbn13 }}&amp;retailer=dymocks&amp;locale=au">Dymocks</option>
                        <option value="http://www.boomerangbooks.com.au/a/b/book_{{ item.isbn13 }}.htm?utm_source=millsandboon&amp;utm_medium=aff&amp;utm_campaign=deeplink">Boomerang Books</option>
                      </select>

                    </div>
                    <span class="mandb-child-titles__format">{{ item.formatName }}</span>
                  </div>
                {{/if}}
              `
      },
      resultHandler: function resultHandler (item) {
        const currentFormat = item.isbn13 && item.formats ? getFormat(item.isbn13, item.formats) : undefined
        item.shopifyUrl = window.Shopify.shop && item.custom.handle ? `/products/${item.custom.handle}` : ''
        item.contributorList = contributorsList(item.contributors)
        item.formatName = currentFormat ? currentFormat.format.name : ''
        return item
      }
    })

    wrapper.style.display = 'block'
  }
}
